<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img src="../images/LogoUp.svg" class="img" />
        </router-link>
      </div>
      <div class="right">
        <ul class="nav">
          <router-link to="/products" class="nav__item">
            <span class="title small">{{ $t(`ITEMS`) }}</span>
          </router-link>
          <li class="nav__item">
            <div class="title small" @click="scrollToSection('#how')">
              {{ $t(`HOW TO JOIN`) }}
            </div>
          </li>
          <router-link to="/contact-us" class="nav__item">
            <span class="title small">{{ $t(`CONTACT FORM`) }}</span>
          </router-link>
        </ul>
        <div class="select-container currency-selector">
          <currency-dropdown
            v-model="curr"
            :options="currOptions"
            @change="selectCurr"
          />
        </div>
        <div class="balance" v-if="$parent.isAuth">
          <button class="button profile-button dark">
            <div class="balance-content">
              <span class="title small gray balance-label">{{
                $t(`Balance:`)
              }}</span>
              <span class="title small amount"
                >{{ Math.floor($parent.profileData.balance * 100) / 100 }}
                <img src="../images/coin.svg" class="currency-icon" alt="coin"
              /></span>
            </div>
            <div class="button plus" @click="$parent.openTopUpModal">
              <img src="../images/plus.svg" class="img" />
            </div>
          </button>
        </div>
        <router-link to="/profile" class="button black" v-if="$parent.isAuth">{{
          $t(`My profile`)
        }}</router-link>
        <div
          class="button steam-login"
          v-if="!$parent.isAuth"
          @click="$parent.openSignInModal"
        >
          {{ $t(`LOGIN WITH STEAM`) }}
        </div>
      </div>
      <!-- Mobile menu button -->
      <div
        class="mob menu-icon"
        @click="$parent.toggleMenu"
        :class="{ active: $parent.menuVisible }"
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </header>
</template>

<script>
import CurrencyDropdown from './CurrencyDropdown.vue'

export default {
  name: 'Header',
  props: ['currency', 'currencyCode', 'currencyValue'],
  components: {
    CurrencyDropdown,
  },
  data: function () {
    return {
      curr: '',
    }
  },
  computed: {
    currOptions() {
      return this.$parent.currencyOptions.map(({ code }) => code)
    },
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue
    },
  },
  mounted() {
    this.curr = this.currencyCode
  },
  methods: {
    selectCurr(selectedCurrency) {
      const nextValue =
        typeof selectedCurrency === 'string' ? selectedCurrency : this.curr
      this.curr = nextValue
      this.changeCurrency(nextValue)
      localStorage.setItem('currency', nextValue)
    },
    changeCurrency(item) {
      this.$emit('changeCurrency', item)
    },
    openSignInModal() {
      this.$emit('openSignInModal')
    },
    scrollToSection(section) {
      this.$emit('scrollToSection', section)
    },
    decrease() {
      if (this.amount > 0) {
        this.amount = this.amount - 1
      } else {
        this.amount = 0
      }
    },
    increase() {
      this.amount = this.amount + 1
    },
    toCheckout() {
      if (this.amount > 0) {
        this.topUpIsVisible = false
        this.$emit('setAmount', this.amount)
        this.$router.push({ path: 'cart', query: { amount: this.amount } })
      }
    },
  },
}
</script>
